import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION39: PdfComponent = {
  type: 'section',
  id: 's39',
  title: '39. Jurisdiction',
  content: [
    {
      type: 'altText',
      id: 's39bullets',
      content: [
        'The parties irrevocably agree that the courts of England and Wales shall have non-exclusive jurisdiction to settle any dispute or claim arising out of, or in connection with, this Agreement, its subject matter or formation (including non-contractual disputes or claims).',
      ],
      boldFirst: false,
    },
  ],
};
